import SimpleBar from "simplebar-react";
import {ReactComponent as ClientsIcon} from "../assets/fonts/feather/users.svg"
import {ReactComponent as DashboardIcon} from "../assets/fonts/feather/home.svg"
import {ReactComponent as WorkersIcon} from "../assets/fonts/feather/user-check.svg"
import {ReactComponent as BookIcon} from "../assets/fonts/feather/book.svg"
import {ReactComponent as MoneyIcon} from "../assets/fonts/feather/dollar-sign.svg"
import {ReactComponent as SettingsIcon} from "../assets/fonts/feather/settings.svg"
import {ReactComponent as TelegramIcon} from "../assets/fonts/feather/send.svg"
import {ReactComponent as StatsIcon} from "../assets/fonts/feather/pie-chart.svg"
import {ReactComponent as ChartIcon} from "../assets/fonts/feather/bar-chart.svg"
import {ReactComponent as PlaningIcon} from "../assets/fonts/feather/calendar.svg"
import {ReactComponent as PercentIcon} from "../assets/fonts/feather/percent.svg"
import SideBarItem from "../components/SideBarItem";
import {useDispatch, useSelector} from "react-redux";
import {toggleAside} from "../actions/main";
import {useEffect, useState} from "react";
import {ClientService} from "../services/ClientService";
import {userService} from "../services/UserService";
import {Dropdown} from "primereact/dropdown";
export default function Sidebar(props){


    const asideStatus = useSelector(function (state){
        return state.asideStatus
    })

    const userData = useSelector(function (state) {
        return state.auth.userData
    });
    const [departments, setDepartments] = useState([]);
    const [currentDepartment, setCurrentDepartment] = useState(null)

    const [clientsLabels, setClientsLabels] = useState([])
    const [clientsCount, setClientsCount] = useState(0)

    const dispatch = useDispatch()


    function handleAsideToggle(){
        if(asideStatus !== 'close_icon')
            dispatch(toggleAside('close_icon'))
        else
            dispatch(toggleAside(''))
    }

    const updateCount = () => {
        if(currentDepartment) {
            ClientService.GetCount({
                filters: [
                    {filter: {read: 0, object_type: 'feedback', dep_id: currentDepartment}},
                    {filter: {read: 0, object_type: 'kindergarten', dep_id: currentDepartment}},
                    {filter: {read: 0, object_type: 'additional_class', dep_id: currentDepartment}},
                    {filter: {read: 0, object_type: 'individual_lesson', dep_id: currentDepartment}},
                ]
            }).then((r) => {
                if (r) {
                    let array = []
                    r.map((el) => {
                        array.push(el)
                    })
                    let s = array.reduce((partialSum, a) => partialSum + a, 0)
                    setClientsCount(s)
                    setClientsLabels(array)
                }
            })
        }
    }

    // console.log(options)

    useEffect(() => {

        // updateCount()
    }, [asideStatus]);


    useEffect(() => {
        updateCount()
    }, [currentDepartment]);

    return (
        <div className={"sidebar-wrapper " + asideStatus}>

                <div className="logo-wrapper">

                    <img src="/logo.svg" alt=""/>



                    <div className="back-btn" onClick={handleAsideToggle}>
                        <i className="fa fa-angle-left">

                        </i>
                    </div>
                </div>

                <div className="logo-icon-wrapper">

                </div>
                <div className="logo-wrapper">

                </div>
                <nav className="sidebar-main">
                    <div className="left-arrow" id="left-arrow">
                        <i data-feather="arrow-left">
                        </i>
                    </div>

                 


                    <div id="sidebar-menu">

                            <SimpleBar className={'sidebar-links'}>


                                {/*<li></li>*/}


                                <SideBarItem title={'Дашборд'} link={'/'} icon={<DashboardIcon/>}/>
                                {/*<SideBarItem title={'Планинг'} link={'/planing'} icon={<PlaningIcon/>}/>*/}

                                <SideBarItem title={'Клиенты'} link={'clients'} isParent={false} icon={<WorkersIcon />}  counter={clientsCount > 0 ? clientsCount : false}/>

                                <br/>
                                <br/>
                                <SideBarItem title={'Артисты'} link={'artists'} isParent={false} icon={<ClientsIcon />}  counter={clientsCount > 0 ? clientsCount : false}/>
                                <SideBarItem title={'Мероприятия'} link={'events'} isParent={false} icon={<PlaningIcon />}  counter={clientsCount > 0 ? clientsCount : false}/>

                                <SideBarItem title={'Касса'} link={'cash'} isParent={false} icon={<MoneyIcon />}/>
                                {/*<SideBarItem title={'Отчеты'} isParent={true} icon={<TelegramIcon />}>*/}
                                {/*    <SideBarItem title={'Детский сад'} link={'clients'}/>*/}
                                {/*</SideBarItem>*/}
                                <SideBarItem title={'Анализ'} isParent={false} link={'analyz'} icon={<StatsIcon />}/>
                                <SideBarItem title={'Аналитика'} isParent={false} link={'analytic_full'} icon={<ChartIcon />}/>
                                <SideBarItem title={'Аналитика сегменты'} isParent={false} link={'analytic'} icon={<ChartIcon />}/>
                                <SideBarItem title={'Продажи по артистам'} isParent={false} link={'artist-sales'} icon={<StatsIcon />}/>
                                <SideBarItem title={'Кухня по артистам'} isParent={false} link={'kitchen-artists'} icon={<ChartIcon />}/>
                                <SideBarItem title={'Калькулятор % артиста'} isParent={false} link={'calc-artist'} icon={<PercentIcon />}/>
                                {/*    <SideBarItem title={'Детский сад'} link={'clients'}/>*/}
                                {/*</SideBarItem>*/}


                            </SimpleBar>

                    </div>
                    <div className="right-arrow" id="right-arrow"><i data-feather="arrow-right"></i></div>
                </nav>

        </div>
    )
}